export { default as StopOutlineIcon } from './StopOutlineIcon';
